import Styled from "styled-components";

export const CardWrap = Styled.section`
    display: flex;
	gap: 2px;
	align-items: center;

	i {
		width: 10px;
		height: 10px;
		position: relative;
		display: inline-block;
	}
`;

export const StarHolder = Styled.i`
	color: rgb(255, 178, 0);
	font-size: 12px;
	line-height: 12px;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;


	& > span {
		display: inline-block;
		height: inherit;
		font-size: 12px;
		line-height: inherit;
		position: absolute;
		left: 4%;
		top: 0;
		overflow: hidden;
	}
	::before,
	span::before {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: ${(props: { width: string }) => props.width};
		cursor: pointer;
	}
`;

export const CardWrapWithMobile = Styled(CardWrap)`
	font-size: 0;
	position: relative;
	padding: 0;
    i {
        height: .625rem;
        width: .625rem;
		position: relative;
    }
`;
